import { create } from 'zustand'

export type PendingUserData = {
  authCode?: string | undefined
  firstName: string
  lastName: string
  email: string
}

type PendingUserStore = PendingUserData & {
  setPendingData: (data: PendingUserData) => void
  setAuthCode: (authCode: string | undefined) => void
}

const usePendingUserStore = create<PendingUserStore>((set) => ({
  authCode: undefined,
  firstName: '',
  lastName: '',
  email: '',
  countryCode: '',
  setPendingData: (data: PendingUserData) => set({ ...data }),
  setAuthCode: (authCode) => set({ authCode }),
}))

export default usePendingUserStore
